import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import {
  CountTitle,
  DashboardCard,
  DashboardCardContainer,
  DashboardContainer,
  DashboardContainerLeft,
  DashboardContainerRight,
  DashboardContainerRightTitle,
  DashboardCountCard,
  DashboardCountCardLeft,
  DashboardCountCardRight,
  DashboardCountContainer,
  DashboardCountContainerLeft,
  DashboardCountContainerRight,
  DashboardCountView,
  OwnerDashboardHeaderContainer,
  DashboardHeaderTitle,
  DashboardTableContainer,
  DashboardTableContent,
  DashboardTableView,
  EditButton,
  FileInput,
  Image,
  LabelCount,
  LoaderWrapper,
  LogoTitle,
  ImageWrapper,
} from './dashboard.style';
import { IconButton, Label, Loader } from '../../../Components/uielements';
import DashboardTable from './table/dashboardTable';
import { useUserContext } from '../../../hooks/UserContext';
import * as UserService from '../../../services/bioplus-services/user';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

// import CVDServices from '../../../services/bioplus-services/cvd';
import LogbookService from '../../../services/bioplus-services/logBook';
import DateUtils from '../../../utils/date-utils';
import CameraOne from '../../../assets/PNG/camera-1.png';
import CameraTwo from '../../../assets/PNG/camera-2.png';

import { IntlMessages } from '../../../helper/langHelper';
import { CenterContainer, TooltipBox } from '../../../Components/uielements/tooltip/tooltip.style';
import { useNavigate } from 'react-router-dom';
import { EditWhiteIcon } from '../../../Components/icons';
import service from '../../../services/bioplus-services/service';
import { managerDashboardInfo } from '../../../services/bioplus-services/dashboard';

const ManagerDashboard = () => {
  const userRole = useUserContext().company;
  const companyId = userRole?.companyId?.id;
  const userDetails = useUserContext()?.user;

  const countsInfo = useQuery('countsInfo', () =>
    managerDashboardInfo(companyId, userRole?.premiseId)
  );

  const query = useQuery(['logBookEntries'], () =>
    LogbookService.listByCompany(
      companyId,
      {
        name: '',
        fromDate: DateUtils.last7Days(),
        toDate: DateUtils.today(),
      },
      0,
      4
    )
  );

  // images upload
  const [image, setImage] = useState(userDetails?.camera1);
  const [imageTwo, setImageTwo] = useState(userDetails?.camera2);
  const [isUploadingOne, setIsUploadingOne] = useState(false);
  const [isUploadingTwo, setIsUploadingTwo] = useState(false);
  const [isFetching, setIsFetching] = useState(false);

  const handleImageChangeOne = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result.split(',')[1];

        const payload = {
          _id: userDetails?._id,
          camera1: base64String,
        };
        setIsUploadingOne(true);
        await UserService.uploadCameraImage(payload);
        setImage(base64String);
        setIsUploadingOne(false);
      };
      reader.readAsDataURL(file);
    }
  };
  const handleImageChangeTwo = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result.split(',')[1];

        const payload = {
          _id: userDetails?._id,
          camera2: base64String,
        };
        setIsUploadingTwo(true);
        await UserService.uploadCameraImage(payload);
        setImageTwo(base64String);
        setIsUploadingTwo(false);
      };
      reader.readAsDataURL(file);
    }
  };

  const navigate = useNavigate();
  const handleNaviagte = (path) => {
    if (path) {
      navigate(path);
    }
  };

  const handleNavigateToProfileUpdate = async () => {
    navigate('/update-profile');
  };

  const tableData = query?.data ?? [];
  // hover tooltip
  const [showTooltipUser, setIsHoveredUser] = useState(false);
  const [showTooltipPremise, setIsHoveredPremise] = useState(false);
  const [showTooltipGeofence, setIsHoveredGeofence] = useState(false);
  const [showTooltipLogBook, setIsHoveredLogBook] = useState(false);
  // const [showTooltipNotification, setIsHoveredNotification] = useState(false);
  const [showTooltipSOS, setIsHoveredSOS] = useState(false);

  const handleMouseEnter = (onSet) => {
    onSet(true);
  };
  const handleMouseLeave = (onSet) => {
    onSet(false);
  };

  const fetchImages = async () => {
    try {
      setIsFetching(true);
      const data = await service.get('users/self', localStorage.getItem('session'));

      if (data) {
        setImage(data?.data?.camera1);
        setImageTwo(data?.data?.camera2);
        setIsFetching(false);
      }
    } catch (error) {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchImages();
  }, []);

  return (
    <DashboardContainer>
      {/* hearder section */}
      <OwnerDashboardHeaderContainer>
        <DashboardHeaderTitle>
          <IntlMessages id="header.dashboard" />
        </DashboardHeaderTitle>{' '}
        <IconButton
          text={<IntlMessages id="text.update.profile" />}
          icon={<ManageAccountsIcon />}
          onClick={handleNavigateToProfileUpdate}
        />
      </OwnerDashboardHeaderContainer>
      {/* card section */}
      <DashboardCardContainer>
        <DashboardContainerLeft>
          <DashboardCard>
            {isUploadingOne || isFetching ? (
              <LoaderWrapper>
                <Loader loadingText="Uploading..." />
              </LoaderWrapper>
            ) : (
              <>
                <EditButton onClick={() => document.getElementById('imageUpload').click()}>
                  <EditWhiteIcon />
                </EditButton>
                <FileInput
                  id="imageUpload"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChangeOne}
                  multiple={false}
                />
                {image ? (
                  <ImageWrapper>
                    <Image src={`data:image/png;base64,${image}`} alt="Camera" />
                  </ImageWrapper>
                ) : (
                  <ImageWrapper>
                    <Image src={CameraOne} alt="camera image" />
                  </ImageWrapper>
                )}
              </>
            )}
            <LogoTitle>CAMERA #1</LogoTitle>
          </DashboardCard>
          <DashboardCard>
            {isUploadingTwo || isFetching ? (
              <LoaderWrapper>
                <Loader loadingText="Uploading..." />
              </LoaderWrapper>
            ) : (
              <>
                <EditButton onClick={() => document.getElementById('imageUploadTwo').click()}>
                  <EditWhiteIcon />
                </EditButton>
                <FileInput
                  id="imageUploadTwo"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChangeTwo}
                  multiple={false}
                />
                {imageTwo ? (
                  <ImageWrapper>
                    <Image src={`data:image/png;base64,${imageTwo}`} alt="Camera" />
                  </ImageWrapper>
                ) : (
                  <ImageWrapper>
                    <Image src={CameraTwo} alt="camera image" />
                  </ImageWrapper>
                )}
              </>
            )}
            <LogoTitle>CAMERA #2</LogoTitle>
          </DashboardCard>
          {/* <DashboardCard image={CameraTwo}>
            <LogoTitle>CAMERA #2</LogoTitle>
          </DashboardCard> */}
        </DashboardContainerLeft>
        <DashboardContainerRight>
          <DashboardContainerRightTitle>CAMERA #1</DashboardContainerRightTitle>
          <DashboardContainerRightTitle>CAMERA #2</DashboardContainerRightTitle>
        </DashboardContainerRight>
      </DashboardCardContainer>
      {/* table view */}
      <DashboardTableContainer>
        <DashboardTableView>
          <DashboardTableContent>
            <Label weight="bold" size="header1" color="lightGreen" transform="uppercase">
              <IntlMessages id="dashboard.visitors" />
            </Label>
            <DashboardTable data={tableData} />
          </DashboardTableContent>
        </DashboardTableView>
        <DashboardCountView>
          <Label weight="bold" size="header1" color="lightGreen" transform="uppercase">
            <IntlMessages id="dashboard.counts" />{' '}
            <span style={{ color: '#fff', paddingLeft: '5px' }}>{userRole?.companyName}</span>
          </Label>
          <DashboardCountContainer>
            <DashboardCountContainerRight>
              <DashboardCountCard onClick={() => handleNaviagte('/roles')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredUser)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredUser)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{countsInfo?.data?.userCount ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.roles" />
                </DashboardCountCardRight>
                {showTooltipUser && (
                  <CenterContainer position={'top'} marginLeft={'-150px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="user.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
              <DashboardCountCard onClick={() => handleNaviagte('/cvd')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredPremise)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredPremise)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{countsInfo?.data?.cvdCount ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>CVD's</DashboardCountCardRight>
                {showTooltipPremise && (
                  <CenterContainer position={'top'} marginLeft={'-150px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="cvd.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
              <DashboardCountCard onClick={() => handleNaviagte('/geofences')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredGeofence)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredGeofence)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{countsInfo?.data?.geofenceCount ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.geofences" />
                </DashboardCountCardRight>{' '}
                {showTooltipGeofence && (
                  <CenterContainer position={'top'} marginLeft={'-150px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="geofence.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
            </DashboardCountContainerRight>
            <DashboardCountContainerLeft>
              <DashboardCountCard onClick={() => handleNaviagte('/logrecords')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredLogBook)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredLogBook)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{countsInfo?.data?.visitorCount ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.records.logRecords" />
                </DashboardCountCardRight>{' '}
                {showTooltipLogBook && (
                  <CenterContainer position={'top'} marginLeft={'-155px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="logbook.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
              {/* <DashboardCountCard onClick={() => handleNaviagte('/notifications')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredNotification)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredNotification)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>
                      <LabelCount>{countsInfo?.data?.notificationCount ?? 0}</LabelCount>
                    </LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.records.notifications" />
                </DashboardCountCardRight>{' '}
                {showTooltipNotification && (
                  <CenterContainer position={'top'} marginLeft={'-155px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="notification.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard> */}
              <DashboardCountCard onClick={() => handleNaviagte('/sos')}>
                <DashboardCountCardLeft>
                  <CountTitle
                    onMouseEnter={() => handleMouseEnter(setIsHoveredSOS)}
                    onMouseLeave={() => handleMouseLeave(setIsHoveredSOS)}
                    style={{ cursor: 'pointer' }}
                  >
                    <LabelCount>{countsInfo?.data?.sosCount ?? 0}</LabelCount>
                  </CountTitle>
                </DashboardCountCardLeft>
                <DashboardCountCardRight>
                  <IntlMessages id="nav.records.sos" />
                </DashboardCountCardRight>{' '}
                {showTooltipSOS && (
                  <CenterContainer position={'top'} marginLeft={'-155px'}>
                    <TooltipBox
                      background={'0B2629'}
                      borderColor={'E6B471'}
                      borderRadius={'10px'}
                      padding={'10px'}
                      textAlign={'left'}
                      width={'260px'}
                    >
                      <Label>
                        <IntlMessages id="sos.hover.info.text" />
                      </Label>
                    </TooltipBox>
                  </CenterContainer>
                )}
              </DashboardCountCard>
            </DashboardCountContainerLeft>
          </DashboardCountContainer>
        </DashboardCountView>
      </DashboardTableContainer>
    </DashboardContainer>
  );
};

export default ManagerDashboard;
